
export const cashConfig = `<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （1）螺丝星球活动时间为2024年6月01日至2025年6月01日；活动范围为所有进入本游戏的用户；本次活动名额仅限前100000名用户。本游戏预计提现最高金额为3000元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （2）请您理解并同意产品内分红及现金发放数量随机；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （3）螺丝星球展示多个提现比例，使用每个提现比例有自己的使用要求，用户达到后方可按对应提现比例进行提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （4）单个用户总提现次数不限，单日最高可提10次。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    您可满足对应提现比例要求后进行提现，具体规则如下：
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （5）【额外提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    用户通过玩游戏、观看视频获得额外提现，用户满足以下条件后即可提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、用户通过1关，可直接提现0.1元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、用户通过3关，可直接提现0.2元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    c、用户通过10关，需要依次满足以下条件后，可提现80元：1）累计开出800辆车；2）累计观看200个视频；3）累计打卡3天，每天开出50辆车；4）活跃等级达到30级；5）每天3个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    d、用户通过15关，需要依次满足以下条件后，可提现180元：1）累计开出1500辆车；2）累计观看300个视频；3）累计打卡5天，每天开出50辆车；4）活跃等级达到30级；5）每天2个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、用户通过20关，需要依次满足以下条件后，可提现360元：1）累计开出2500辆车；2）累计观看400个视频；3）累计打卡10天，每天开出50辆车；4）活跃等级达到30级；5）每天1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    f、用户通过30关，需要依次满足以下条件后，可提现800元：1）累计开出4000辆车；2）累计观看500个视频；3）累计打卡15天，每天开出50辆车；4）活跃等级达到30级；5）每天1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （6）【红包提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、1000元游戏红包=1元人民币，用户通过玩游戏、观看视频获得游戏红包，用户可提现金额=所选提现汇率*当前现金账户余额，可提现金额达到0.1元方可进行提现，最大提现额度限制为1000元，每天10次提现机会，无时间限制或注册时长限制。当用户累计提现的金额+当前提现的余额<累计看广告为平台产生的收益即可提现，当不满足时，会提示用户继续游戏，并在达到下一目标后再次判定。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、1000元红包=1元人民币：无要求，新用户均可按1%比例提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    c、1000元红包=1.2元人民币：需要通过7关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    d、1000元红包=1.5元人民币：需要通过11关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、1000元红包=1.8元人民币：需要通过16关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    f、1000元红包=2元人民币：需要通过21关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    g、1000元红包=10元人民币：需要满足以下几个条件即可成功提现：1）需要通过26关；2）累计开出3500辆车；3）累计打卡5天，每天开出50辆车；4）累计观看500个视频；5）活跃等级达到30级。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    h、1000元红包=100元人民币：需要满足以下几个条件即可成功提现：1）需要通过31关；2）累计开出4500辆车；3）累计打卡10天，每天开出50辆车；4）累计观看700个视频；5）活跃等级达到30级。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    i、1000元红包=1000元人民币：需要满足以下几个条件即可成功提现：1）需要通过40关；2）累计开出6000辆车；3）累计打卡15天，每天开出50辆车；4）累计观看900个视频；5）活跃等级达到30级。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （7）【图鉴提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    图鉴提现要求集齐一套车图鉴即可提现3000元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （8）【好友提现】提现规则： 部分提现需要认证账号无风险，若有风险需要邀请好友验证辅助提现。邀请第一个新用户最高可得5元奖励，第二个最高可得10元奖励，第三个最高可得15元奖励。被邀请用户成功提现并完成3个订单即可成为有效好友。邀请好友提现收益由被邀请有效好友的红包收益决定，被邀请有效好友每次观看广告获得的红包会以10%的比例额外奖励给邀请方。邀请好友收益满0.3元即可提现，每天上限提现10次，无其他提现要求。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （9）产品内活跃等级共有30级，观看一定次数的视频广告即可升级，无其他要求，等级与对应的观看次数对应关系如下（前为观看次数，后为对应等级数，等级间以逗号分割）： "0":1级,"2":2级,"3":3级,"4":4级,"5":5级,"6":6级,"7":7级,"8":8级,"9":9级,"10":10级,"15":11级,"20":12级,"25":13级,"30":14级,"40":15级,"50":16级,"60":17级,"70":18级,"80":19级,"100":20级,"120":21级,"140":22级,"160":23级,"180":24级,"200":25级,"300":26级,"500":27级,"800":28级,"1000":29级,"300000":30级 。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （10）由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （11）单笔提现金额最低0.1元，最高金额为1000元。每日最多10次提现，除下述提及的档位提现要求以外，无注册时长条件，无在线时长条件，无提现间隔条件，无等级条件要求，无邀请好友，总体提现次数不限。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （12）上述“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，无其他要求，不同用户花费的时长也不一样。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （13）不同用户的广告收益不同，广告结束后会根据用户的广告价值计算和发放，不同用户达到对应档位的余额，时间也不一致。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （14）螺丝星球保留对本产品的最终解释权，若发现用户有外挂等恶意作弊行为，一律封禁账号并扣除账户所有余额。
    </span>
</p>`;
